import { UserEntity, UserEntityApi } from './entity';

export const normalizeUserEntity = (raw: UserEntityApi): UserEntity => {
  return {
    email: raw.email,
    dateJoined: new Date(raw.date_joined),
    lastName: raw.last_name,
    isActive: raw.is_active,
    firstName: raw.first_name,
    isStaff: raw.is_staff,
    isCompanySuperuser: raw.is_company_superuser,
  };
};
